module.exports = __webpack_public_path__ + "img/chengshi3.4df48b8c.jpg";